///
/// EarthBrowser
///
/// Migration v31 to v32: Remove command palette open flag
/// Created by Matt Giger on 9/11/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v31 to v32
 *
 * Changes:
 * - Removes userInterface.commandPaletteOpen (the Cmd-K command palette was
 *   merged into the Layers panel, whose open state lives in the ephemeral
 *   dialog slice and is not persisted)
 */
interface StateV31 {
	userInterface?: {
		commandPaletteOpen?: unknown
	}
}

export function migrateV31toV32(state: unknown): unknown {
	const s = state as StateV31 | null | undefined
	if (!s?.userInterface) return state

	const userInterface = { ...s.userInterface }
	delete userInterface.commandPaletteOpen

	return {
		...s,
		userInterface,
	}
}
